module.exports = __webpack_public_path__ + "img/04-主要功能.820d9360.png";